// extracted by mini-css-extract-plugin
export default {"container":"Delivery_container__vFXlb","caruselBox":"Delivery_caruselBox__IKZcq"};